import React from 'react';
import { Modal, Frame } from '@kajabi/sage-react';

import { useResultContext } from 'common/components/CopyMagic/contexts';

import ApplyButton from 'common/components/CopyMagic/components/ApplyButton';
import DiscardButton from 'common/components/CopyMagic/components/DiscardButton';
import FeedbackSentiment from 'common/components/CopyMagic/components/FeedbackSentiment';

const FooterActions = () => {
  const { result } = useResultContext();
  if (!result) return null;

  return (
    <Modal.Footer>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        width={Frame.WIDTHS.FILL}
      >
        <FeedbackSentiment />
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={Frame.DIRECTIONS.HORIZONTAL}
          width={Frame.WIDTHS.FLEX}
        >
          <DiscardButton />
          <ApplyButton />
        </Frame>
      </Frame>
    </Modal.Footer>
  );
};

export default FooterActions;
